import PropTypes from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import Row from "react-bootstrap/Row";
import { Notification } from "ui/notification";
import { getErrorMessage } from "util/response";

class ForgotPasswordPage extends React.PureComponent {
  static get propTypes() {
    return {
      onForgotPassword: PropTypes.func.isRequired,
      title: PropTypes.string.isRequired,
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      email: "",
      emailSent: false,
      errorMessage: null,
    };

    this.doForgotPassword = this.doForgotPassword.bind(this);
    this.onUpdateEmail = this.onUpdateEmail.bind(this);
  }

  onUpdateEmail(e) {
    this.setState({ email: e.target.value });
  }

  doForgotPassword() {
    const { onForgotPassword } = this.props;
    const { email } = this.state;

    return onForgotPassword(email)
      .then(() => this.setState({ emailSent: true }))
      .catch((resp) => this.setState({ errorMessage: getErrorMessage(resp) }));
  }

  _renderForm() {
    const { errorMessage } = this.state;

    return (
      <div>
        <p className="login-box-msg">Please enter your email address</p>
        <Notification error={errorMessage} />
        <FormGroup>
          <FormControl
            type="email"
            placeholder="Email"
            onChange={this.onUpdateEmail}
          />
        </FormGroup>
        <Row>
          <Col xs={{ span: 4, offset: 8 }}>
            <Button variant="primary" onClick={this.doForgotPassword}>
              Reset Password
            </Button>
          </Col>
        </Row>
      </div>
    );
  }

  _renderSuccess() {
    return (
      <p className="login-box-msg">
        Password reset email is sent. Please check your inbox.
      </p>
    );
  }

  _renderBox() {
    const { emailSent } = this.state;

    return emailSent ? this._renderSuccess() : this._renderForm();
  }

  render() {
    const { title } = this.props;

    return (
      <div className="login-page">
        <div className="header">
          <h1>{title}</h1>
        </div>
        <div className="login-box">
          <div className="login-box-body">{this._renderBox()}</div>
        </div>
      </div>
    );
  }
}

export { ForgotPasswordPage };
